import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-features-style-six',
  templateUrl: './features-style-six.component.html',
  styleUrls: ['./features-style-six.component.scss']
})
export class FeaturesStyleSixComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
